<nav class="ui-tabbar" [attr.aria-label]="ariaLabel()">
  @for (item of items(); track item.id) {
    <button
      class="ui-tabbar-item"
      type="button"
      [class.ui-tabbar-item-active]="item.id === activeItemId()"
      [disabled]="item.disabled === true"
      [attr.aria-current]="item.id === activeItemId() ? 'page' : null"
      [attr.aria-label]="item.ariaLabel ?? item.label"
      (click)="handleItemSelected(item)"
    >
      @if (item.iconName || item.iconLabel) {
        <span class="ui-tabbar-icon" aria-hidden="true">
          @switch (item.iconName) {
            @case ('clock') {
              <svg viewBox="0 0 24 24" focusable="false">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l4 2" />
              </svg>
            }
            @case ('book-marked') {
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path
                  d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                />
                <path d="M10 2v8l3-3 3 3V2" />
              </svg>
            }
            @case ('users') {
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            }
            @case ('heart') {
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M19.5 12.6 12 20l-7.5-7.4A5 5 0 0 1 12 6.1a5 5 0 0 1 7.5 6.5z"
                />
              </svg>
            }
            @default {
              {{ item.iconLabel }}
            }
          }
        </span>
      }
      <span class="ui-tabbar-label">{{ item.label }}</span>
    </button>
  }
</nav>
